import Vue from 'vue';
//配置路由
import VueRouter from 'vue-router'
Vue.use(VueRouter);
// 解决多次点击左侧菜单报错问题
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
//1.创建组件
import Index from '@/views/index'
import Home from '@/views/home'
import Login from '@/views/login'
import NotFound from '@/views/404'
import UpdatePassword from '@/views/update-password'
import pay from '@/views/pay'
import register from '@/views/register'
import center from '@/views/center'

import users from '@/views/modules/users/list'
import dictionary from '@/views/modules/dictionary/list'
import consult from '@/views/modules/consult/list'
import sysOrg from '@/views/modules/sysOrg/list'
import dictionaryOrgType from '@/views/modules/dictionaryOrgType/list'
import dicitonaryMenuBtn from '@/views/modules/dicitonaryMenuBtn/list'
import dicitonaryCocalType from '@/views/modules/dicitonaryCocalType/list'
import dicitonaryCompanyType from '@/views/modules/dicitonaryCompanyType/list'
import sysAppVersion from '@/views/modules/sysAppVersion/list'
import cocalTemplate from '@/views/modules/cocalTemplate/list'
import sysRole from '@/views/modules/sysRole/list'
import menu from '@/views/modules/menu/list'
import port from '@/views/modules/port/list'
import company from '@/views/modules/company/list'
import cocalRankingList from '@/views/modules/charts/cocal-ranking-list'
import cocalSweepList from '@/views/modules/charts/cocal-sweep-list'
import cocalPingcangList from '@/views/modules/charts/cocal-pingcang-list'
import cocalPortList from '@/views/modules/charts/cocal-port-list'
import adver from '@/views/modules/adver/list'
import cocalMatchResult from '@/views/modules/cocalMatchResult/list'
import cocalSale from '@/views/modules/cocalSale/list'
import cocalTemplateOwner from '@/views/modules/cocalTemplateOwner/list'
import baseCocalConfig from '@/views/modules/baseCocalConfig/list'
import bestCocalMatchConfig from '@/views/modules/bestCocalMatchConfig/list'
import cocalPriceChart from '@/views/modules/cocalPriceChart/list'
import dicitonaryPortName from '@/views/modules/dicitonaryPortName/list'
import baseSitePortConfig from '@/views/modules/baseSitePortConfig/list'
import payType from '@/views/modules/payType/list'
import recommendUpdate from '@/views/modules/sysRecommend/recommend-update'
import privacyPolicyUpdate from '@/views/modules/privacyPolicyDetail/privacy-policy-update'
import userAgreementUpdate from '@/views/modules/userAgreementDetail/user-agreement-update'
import memberAgreementUpdate from '@/views/modules/userAgreementDetail/member-agreement-update'
import suggestion from '@/views/modules/suggestion/list'
import course from '@/views/modules/course/list'
import customer from '@/views/modules/customer/list'
import basePriceStationConfig from '@/views/modules/basePriceConfig/base-price-station-config-list'
import basePricePortConfig from '@/views/modules/basePriceConfig/base-price-port-config-list'
import cocalPortMessage from '@/views/modules/cocalPortMessage/list'
import auctionCalculation from '@/views/modules/auctionCalculation/list'
import userPoints from '@/views/modules/UserPoints/list'
import stationMessage from '@/views/modules/stationMessage/list'
import portMatchResult from '@/views/modules/portMatchResult/list'
import cocalShareUserMessage from '@/views/modules/cocalShareUserMessage/list'
import wxBestMatchResult from '@/views/modules/weinxin/wx-best-match-result'
import coalMatchResult from '@/views/modules/weinxin/coal-match-result'
import videoCourse from '@/views/video-course'
import video from '@/views/modules/video/list'
import payRecords from '@/views/modules/payRecords/list'

//2.配置路由   注意：名字
const routes = [{
    path: '/index',
    name: '首页',
    component: Index,
    children: [{
        // 这里不设置值，是把main作为默认页面
        path: '/',
        name: '首页',
        component: Home,
        meta: {icon:'', title:'center'}
    }, {
        path: '/updatePassword',
        name: '修改密码',
        component: UpdatePassword,
        meta: {icon:'', title:'updatePassword'}
    }, {
        path: '/center',
        name: '个人信息',
        component: center,
        meta: {icon:'', title:'center'}
    }, {
        path: '/videoCourse',
        name: 'WEB端视频教程',
        component: videoCourse,
        meta: {icon:'', title:'videoCourse'}
    }, {
        path: '/video',
        name: '视频管理',
        component: video
    }, {
        path: '/users',
        name: '管理信息',
        component: users
    }
        ,{
            path: '/dictionary',
            name: '字典',
            component: dictionary
        },{
            path: '/consult',
            name: '咨询管理',
            component: consult
        },{
            path: '/sysOrg',
            name: '组织管理',
            component: sysOrg
        },{
            path: '/dictionaryOrgType',
            name: '组织类型维护',
            component: dictionaryOrgType
        },{
            path: '/dicitonaryMenuBtn',
            name: '菜单按钮类型维护',
            component: dicitonaryMenuBtn
        },{
            path: '/dicitonaryCocalType',
            name: '煤种类型维护',
            component: dicitonaryCocalType
        },{
            path: '/dicitonaryCompanyType',
            name: '公司类型维护',
            component: dicitonaryCompanyType
        },{
            path: '/dicitonaryPortName',
            name: '港口名称维护',
            component: dicitonaryPortName
        },{
            path: '/sysRole',
            name: '角色管理',
            component: sysRole
        },{
            path: '/menu',
            name: '菜单管理',
            component: menu
        },{
            path: '/cocalTemplate',
            name: '煤种模板',
            component: cocalTemplate
        },{
            path: '/cocalRankingList',
            name: '煤源排行',
            component: cocalRankingList
        },{
            path: '/cocalSweepList',
            name: '车板价排行',
            component: cocalSweepList
        },{
            path: '/port',
            name: '港口数据维护',
            component: port
        },{
            path: '/cocalPingcangList',
            name: '平仓价排行',
            component: cocalPingcangList
        },{
            path: '/adver',
            name: '广告内容',
            component: adver
        },{
            path: '/company',
            name: '公司管理',
            component: company
        },{
            path: '/cocalMatchResult',
            name: '配煤记录',
            component: cocalMatchResult
        },{
            path: '/cocalPortList',
            name: '到港价排行',
            component: cocalPortList
        },{
            path: '/cocalTemplateOwner',
            name: '自建库煤源',
            component: cocalTemplateOwner
        },{
            path: '/baseCocalConfig',
            name: '煤源基础参数配置',
            component: baseCocalConfig
        },{
            path: '/bestCocalMatchConfig',
            name: '每日最优煤源配置',
            component: bestCocalMatchConfig
        },{
            path: '/cocalPriceChart',
            name: '价格煤源走势',
            component: cocalPriceChart
        },{
            path: '/baseSitePortConfig',
            name: '场地-港口关系维护',
            component: baseSitePortConfig
        },{
            path: '/course',
            name: '教程管理',
            component: course
        },{
            path: '/customer',
            name: '系统客服',
            component: customer
        },{
            path: '/cocalPortMessage',
            name: '港口收煤报价',
            component: cocalPortMessage
        },{
            path: '/wxBestMatchResult',
            name: '小程序每日最优配煤',
            component: wxBestMatchResult
        },{
            path: '/coalMatchResult',
            name: '小程序配煤记录',
            component: coalMatchResult
        },{
            path: '/basePriceStationConfig',
            name: '场地费配置',
            component: basePriceStationConfig
        },{
            path: '/basePricePortConfig',
            name: '港杂费配置',
            component: basePricePortConfig
        },{
            path: '/suggestion',
            name: '意见管理',
            component: suggestion
        },{
            path: '/sysAppVersion',
            name: 'APP版本控制',
            component: sysAppVersion
        },{
            path: '/recommendUpdate',
            name: '系统介绍',
            component: recommendUpdate
        },{
            path: '/payType',
            name: '支付类型维护',
            component: payType
        },{
            path: '/userPoints',
            name: '会员积分明细',
            component: userPoints
        },{
            path: '/privacyPolicyUpdate',
            name: '隐私政策维护',
            component: privacyPolicyUpdate
        },{
            path: '/userAgreementUpdate',
            name: '用户协议',
            component: userAgreementUpdate
        },{
            path: '/memberAgreementUpdate',
            name: '会员服务协议',
            component: memberAgreementUpdate
        },{
            path: '/auctionCalculation',
            name: '竞拍测算',
            component: auctionCalculation
        },{
            path: '/stationMessage',
            name: '站点收煤',
            component: stationMessage
        },{
            path: '/portMatchResult',
            name: '港口配煤',
            component: portMatchResult
        },{
            path: '/cocalShareUserMessage',
            name: '意向客户',
            component: cocalShareUserMessage
        },{
            path: '/payRecords',
            name: '订单管理',
            component: payRecords
        },{
            path: '/cocalSale',
            name: '在售煤源信息',
            component: cocalSale
        }

    ]
},
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {icon:'', title:'login'}
    },
    {
        path: '/register',
        name: 'register',
        component: register,
        meta: {icon:'', title:'register'}
    },
    {
        path: '/',
        name: '首页',
        redirect: '/index'
    }, /*默认跳转路由*/
    {
        path: '*',
        component: NotFound
    }
]
//3.实例化VueRouter  注意：名字
const router = new VueRouter({
    mode: 'hash',
    /*hash模式改为history*/
    routes // （缩写）相当于 routes: routes
})

export default router;